jQuery(document).ready(function($) {
    
    const $notificationBar = $('#menu-notification-bar');
    const $notifications = $notificationBar.find('li');
    const totalNotifications = $notifications.length;

    // S'il n'y a qu'une seule notification, le défilement est inutile
    if (totalNotifications < 2) return;

    let currentIndex = 0;

    function jumpNotification() {
        currentIndex++;

        // Si l'index atteint le nombre total de notifications, on retourne au début (0)
        if (currentIndex >= totalNotifications) {
            currentIndex = 0;
        }

        // On récupère la hauteur réelle d'un LI (ici, 24px selon votre CSS)
        const itemHeight = $notifications.first().outerHeight();
        
        // On calcule la position où le scroll doit sauter
        const scrollPosition = currentIndex * itemHeight;

        // OPTION 1 : Saut brutal et instantané (décommentez la ligne ci-dessous si vous préférez cet effet)
        // $notificationBar.scrollTop(scrollPosition);

        // OPTION 2 : Saut fluide très rapide (300ms) pour que l'œil suive le mouvement
        $notificationBar.animate({
            scrollTop: scrollPosition
        }, 300); 
    }

    // Lance la fonction toutes les 3 secondes (3000 ms). Vous pouvez ajuster ce temps.
    setInterval(jumpNotification, 3000);

});